/**
 * User: n.gorte
 * Date: 20.10.2020
 * Time: 16:13
 */
import L from 'external/leaflet';

export const ColorPickerControl = L.Control.extend({
    options: {
        position: 'bottomleft'
    },

    initialize(options = {
        active: false
    }) {
        L.Util.setOptions(this, options);
        this._active = options.active;
    },

    onAdd(map) {
        this._map = map;
        let container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');

        container.style.cursor = 'pointer';
        container.style.height = '100px';
        container.style.width = '130px';

        let slider = document.createElement('div');
        slider.style.float = 'left';
        slider.style.height = '100px';
        slider.style.width = '26px';
        this._slider = slider;

        let picker = document.createElement('div');
        picker.style.float = 'right';
        picker.style.height = '100px';
        picker.style.width = '100px';
        this._picker = picker;

        container.appendChild(slider);
        container.appendChild(picker);

        container.addEventListener('mouseover', () => {
            map.dragging.disable();
        });
        container.addEventListener('mouseout', () => {
            map.dragging.enable();
        });

        container.addEventListener('click', (e) => {
            L.DomEvent.stop(e);
        });

        return container;
    },

    enable() {
        this._active = true;
    },

    disable() {
        this._active = false;
    },

    isActive() {
        return this._active;
    },

    getSliderElement() {
        return this._slider;
    },

    getPickerElement() {
        return this._picker;
    }
});



// WEBPACK FOOTER //
// ./js/plugins/DrawerPlugin/ColorPickerControl.js